// Vendor Libraries
import { createSelector } from '@ngrx/store';
// Utils / Constants
import { FUND_SCREENER_IDENTIFIER, STOCK_SCREENER_APP_STATE_SLICE_KEY, STOCK_SCREENER_IDENTIFIER, } from 'ScreenerApp/ts/features/screener/constants';
// Getter Selectors for accessing slices of root store
export const getAppStateSliceKey = ({ appStateSliceKey }) => appStateSliceKey;
export const getScreenerState = ({ appStateSliceKey, ...state }) => state[appStateSliceKey];
export const getScreenerScoringModelsState = (state) => state.scoringModels;
// Selector returning the screener's type ('company' or 'fund')
export const getScreenerType = createSelector(getAppStateSliceKey, (appStateSliceKey) => appStateSliceKey === STOCK_SCREENER_APP_STATE_SLICE_KEY ? STOCK_SCREENER_IDENTIFIER : FUND_SCREENER_IDENTIFIER);
